require('./bootstrap');
require('./script');
require('./front-common');